import React, { createContext, useContext, useState, useEffect } from "react";
import toast from "react-hot-toast";

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // restore user from localStorage
  useEffect(() => {

    try {

      const storedUser = localStorage.getItem("ms-bridal-user");

      if (storedUser) {
        setUser(JSON.parse(storedUser));
      }

    } catch (error) {

      console.error("Auth restore error:", error);
      localStorage.removeItem("ms-bridal-user");

    } finally {

      setLoading(false);

    }

  }, []);

  const login = (userData) => {

    setUser(userData);

    localStorage.setItem(
      "ms-bridal-user",
      JSON.stringify(userData)
    );

    toast.success(`Welcome, ${userData?.name || "User"} 👑`);

  };

  const logout = () => {

    setUser(null);

    localStorage.removeItem("ms-bridal-user");

    toast.success("Logged out successfully 👋");

  };

  const value = {
    user,
    login,
    logout,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );

};